import React from 'react';
import { AppState } from 'core/redux/reducers';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { BookingStep1 } from 'core/redux/features/booking/types';
import { selectStepData } from 'core/redux/features/shared/reducers';
import { BOOKING_STEP1 } from 'core/redux/features/booking/constants';
import { createSelector } from 'reselect';

interface IProps {
  selected: number;
  onChange?: (seat: number) => void;
  status: string;
  onlyTableSize?: number;
}

const selectAvailableSeat = createSelector(
  [(seats: number[]) => seats, (_, onlyTableSize: number) => onlyTableSize],
  function (seats, onlyTableSize) {
    return seats
      .map(seat => {
        if (seat !== 0 && onlyTableSize && onlyTableSize !== seat) {
          return null;
        }
        return seat;
      })
      .filter(Boolean);
  },
);
export const ProductMenuSelectToggle = ({
  onChange,
  selected,
  status,
  onlyTableSize,
}: IProps) => {
  // const step = useSelector((state: AppState) =>
  //   selectStepData(state, 'booking', BOOKING_STEP1),
  // ) as BookingStep1;

  const { seats } = useSelector((state: AppState) => ({
    seats: state.booking.seat_menu_options,
    loading: state.booking.loading,
  }));

  const availableSeats = selectAvailableSeat(seats, onlyTableSize);

  const increaseIndex = () => {
    if (status !== 'in-stock') {
      return;
    }

    const currentIndex = availableSeats.indexOf(selected);
    const nextIndex = currentIndex + 1;

    if (nextIndex > availableSeats.length - 1) {
      return;
    }
    onChange(availableSeats[nextIndex]);
  };

  const decreaseIndex = () => {
    if (status !== 'in-stock') {
      return;
    }

    const currentIndex = availableSeats.indexOf(selected);

    const nextIndex = currentIndex - 1;

    if (nextIndex < 0) {
      onChange(0);
      return;
    }

    if (nextIndex < 0) {
      return;
    }
    onChange(availableSeats[nextIndex]);
  };

  return (
    <div className="is-flex-mid" style={{ height: '50px', width: '100px' }}>
      <button
        className={`button is-button-increase`}
        onClick={e => {
          e.preventDefault();
          decreaseIndex();
        }}
        style={{
          borderRadius: '100%',
          padding: '1rem',
          width: '25px',
          height: '25px',
          border: 0,
          background: '#eeeeee',
          fontSize: '1rem',
          position: 'relative',
        }}
      >
        <span
          style={{
            position: 'absolute',
            width: '32px',
            height: '32px',
            paddingTop: '15px',
            left: 0,
            right: 0,
            top: 0,
            display: 'block',
            lineHeight: 0,
          }}
        >
          -
        </span>
      </button>
      <div style={{ marginLeft: '5px', marginRight: '5px' }}>{selected}</div>
      <button
        onClick={e => {
          e.preventDefault();
          increaseIndex();
        }}
        className={`button is-button-increase is-red-dark`}
        style={{
          borderRadius: '100%',
          padding: '1rem',
          width: '25px',
          height: '25px',
          border: 0,
          fontSize: '1rem',
        }}
      >
        <span
          style={{
            position: 'absolute',
            width: '32px',
            height: '32px',
            paddingTop: '15px',
            left: 0,
            right: 0,
            top: 0,
            display: 'block',
            lineHeight: 0,
          }}
        >
          +
        </span>
      </button>
    </div>
  );
};

const ProductMenuSelect = ({
  onChange,
  selected,
  status,
  onlyTableSize,
}: IProps) => {
  const step = useSelector((state: AppState) =>
    selectStepData(state, 'booking', BOOKING_STEP1),
  ) as BookingStep1;

  const { seats, loading } = useSelector((state: AppState) => ({
    seats: state.booking.seat_menu_options,
    loading: state.booking.loading,
  }));

  return (
    <div className="field">
      <div className="control">
        <span
          className={classNames(
            'select select--haslabel is-fullwidth',
            (seats.length < 2 ||
              step.data.time === '0' ||
              loading ||
              status !== 'in-stock') &&
              'disabled',
          )}
        >
          <span className="select-label"> {selected}</span>
          <select
            onChange={e => onChange(parseInt(e.target.value))}
            name="menus"
            className="invi-select invi-select--ios-fix"
            value={selected}
          >
            {seats.length > 1 && status === 'in-stock' ? (
              seats.map(seat => {
                if (seat !== 0 && onlyTableSize && onlyTableSize !== seat) {
                  return null;
                }
                return (
                  <option key={seat} value={seat}>
                    {seat}
                  </option>
                );
              })
            ) : (
              <option value={0}>0</option>
            )}
          </select>
        </span>
      </div>
    </div>
  );
};

ProductMenuSelect.defaultProps = {
  selected: 0,
};

export default ProductMenuSelect;
